import axios from "axios";
import { store } from "../store";
import { v4 as uuidv4 } from 'uuid';

const fileStorageApiRequest = axios.create({
  baseURL: process.env.REACT_APP_FILE_STORAGE_API,
  headers: {
    'x-api-key': process.env.REACT_APP_FILE_STORAGE_API_KEY,
    AccessType: 1,
    moduleId: process.env.REACT_APP_MODULE_ID,
  }
});

export interface PresignedResponse {
  action: string;
  url: string;
  key?: string;
  publicUrl?: string;
  prefix?: string;
  bucket?: string;
}

export const getEmailPresignedUrl = async (
  ruc: string,
  emailType: string,
  action: 'list' | 'upload' | 'delete' | 'download',
  key?: string,
  contentType?: string
): Promise<PresignedResponse | null> => {
  const authCompanySelectedState = store.getState().auth.companyselected;
  const headers = {
    token: authCompanySelectedState?.Token,
    ModuleId: process.env.REACT_APP_MODULE_ID,
    AccessType: 1,
  };
  try {
    const response = await fileStorageApiRequest.post(
      "/email-config/presigned",
      { ruc, emailType, action, key, contentType },
      { headers }
    );
    return response.data as PresignedResponse;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const listEmailFiles = async (ruc: string, emailType: string) => {
  const data = await getEmailPresignedUrl(ruc, emailType, 'list');
  if (!data) return [];
  const response = await axios.get(data.url);
  return response.data.Contents || [];
};

export const uploadEmailFile = async (
  ruc: string,
  emailType: string,
  key: string,
  file: File
): Promise<string | null> => {
  const data = await getEmailPresignedUrl(ruc, emailType, 'upload', key, file.type);
  if (!data) return null;
  await axios.put(data.url, file, {
    headers: { 'Content-Type': file.type }
  });
  return data.publicUrl || null;
};

export const deleteEmailFile = async (
  ruc: string,
  emailType: string,
  key: string
): Promise<boolean> => {
  const data = await getEmailPresignedUrl(ruc, emailType, 'delete', key);
  if (!data) return false;
  await axios.delete(data.url);
  return true;
};

export const fetchEmailHtml = async (ruc: string, emailType: string): Promise<string | null> => {
  const data = await getEmailPresignedUrl(ruc, emailType, 'download', 'body.html');
  if (!data) return null;
  const response = await axios.get(data.publicUrl || data.url, {headers: {
      'Cache-Control': 'no-cache'
    }});
  return response.data;
};

export const generateUniqueImageKey = (originalName: string): string => {
  const ext = originalName.split('.').pop() || 'png';
  return `image_${uuidv4()}.${ext}`;
};